<template>
    <header class="bg-white print:hidden">
        <div class="container bg-white">
            <div class="c-header py-2 xl:py-4">
                <div class="flex flex-col md:flex-row justify-between">
                    <!--<div class="flex w-full items-center justify-end mt-4 md:mt-0">
                        <Topmenu />
                    </div>-->
                </div>
            </div>
        </div>
        <div class="c-top-menu__container white">
            <div class="container">
                <div class="c-top-menu pb-2 flex md:flex-wrap md:content-center">
                    <div class="w-3/4 xl:w-7/12 flex justify-start py-2">
                        <a href="/" class="flex items-center">
                            <img :v-if="model.header.mainLogoUrl" :src="model.header.mainLogoUrl" />
                            <img class="hidden md:inline-block pl-1.5 max-w-md lg:max-w-xl" :v-if="model.header.mainLogoSloganUrl" :src="model.header.mainLogoSloganUrl" />
                        </a>
                    </div>
                    <div class="w-1/4 xl:w-5/12 flex justify-end">
                        <div class="w-full py-6 hidden xl:inline-block">
                            <Search :searchPage="model.searchPage" class="flex" />
                        </div>
                        <Menu :menu="model.menu" />
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="c-header pb-6  xl:hidden">
                <Search :searchPage="model.searchPage" class="flex" />
            </div>
        </div>
    </header>
</template>

<script>
import Menu from '@/Scripts/components/organisms/Menu/menu.vue';
import Topmenu from './topmenu.vue';
import Search from './search.vue';

export default {
    props: ['model'],
    components: {
        Menu,
        Topmenu,
        Search
    },
    data() {
        return {
            hdirLogo: '/Assets/Images/Hdir-logo-white.png?width=320',
            addBorderBottom: !this.isCategoryPage(),
            showMobileSearch: false
        };
    },
    methods: {
        log(msg) {
            console.log(msg);
        },
        isCategoryPage() {
            return this.model.contentType.includes('KategoriPage');
        }
    }
};
</script>
